<template lang='pug'>
div
  letter-head(:no-padding='true')
    .printable-title.top(v-if='model && request')
      .title {{ model.request_name }}
        small
          i.mat-icon date_range
          |  {{ $formatDate(model.delivery_date) }}
        small
          i.mat-icon person
          |  {{ request.people }}
          div ORDER&nbsp;
            strong.cl-menu \#{{ model.id }}
          div INVOICE&nbsp;
            strong.cl-menu \#{{ model.invoice_id }}
  page-content(v-if='model')
    .printable-bottom.size
      el-row(:gutter='$rowGutter')
        el-col(:span='8', v-if='pickupAddress')
          small
            .bigger
              i.mat-icon.cl-primary access_time
              strong  {{ $formatTime(model.delivery_pickup_time) }}
        el-col(:span='8')
          small
            .bigger
              i.mat-icon.cl-primary access_time
              strong  {{ $formatTime(model.delivery_time) }}
      el-row.indent(:gutter='$rowGutter')
        el-col(:span='8', v-if='pickupAddress')
          
          .subtitle Pickup Address
          .address
            |  {{ model.vendor_name }}
          .address
            |  {{ pickupAddress.address_line_1 }}
            .secondary(v-if='pickupAddress.address_line_2') {{ pickupAddress.address_line_2 }}
            .secondary(v-else)
              em.cl-light &nbsp;
            .secondary {{ pickupAddress.city }}, {{ pickupAddress.state }} {{ pickupAddress.zip_code }}
        el-col(:span='8')
          .subtitle Delivery Address
          .address(v-if='contact')
            |  {{contact.first_name }}  {{contact.last_name }}
          .address(v-if='deliveryAddress')
            |  {{ deliveryAddress.address_line_1 }}

            template(v-if='request')
                  .address-2(v-if='request.suite') Suite: {{request.suite}}
            .secondary(v-if='deliveryAddress.address_line_2') {{ deliveryAddress.address_line_2 }}
            .secondary(v-else)
              em.cl-light &nbsp;
            .secondary {{ deliveryAddress.city }}, {{ deliveryAddress.state }} {{ deliveryAddress.zip_code }}
        el-col(:span='8', v-if='model')
          .subtitle Contact
          .address
            strong {{ model.customer_account_name }}
            br
            div(v-if='contact')
              | {{ contact.salutation }} {{ contact.first_name }} {{ contact.last_name }}
              br
              | {{ contact.phone_number }}


    el-table(:data='orderItems', v-if='model != null')
      el-table-column(prop='quantity', label='QTY', width='65')
        template(slot-scope='scope')
          .printable-checkbox
          span {{ scope.row.quantity }}
      el-table-column(prop='name', label='Name')
        template(slot-scope='scope')
          span {{ scope.row.name }}
      el-table-column(label='Delivery Notes')
        template(slot-scope='scope')
          span {{ scope.row.product_notes }}

    .printable-bottom
      el-row(:gutter='$rowGutter')
        el-col(:span='12', v-if='model')
          .subtitle Notes
          blockquote.classic(v-if='model.purchase_order_notes') {{ model.purchase_order_notes }}
          em(v-else) (None)
      .signature-line Receieved By: (Please print and sign)
</template>

<script>
  import LetterHead from './LetterHead.vue'
  import PageContent from './PageContent.vue'

  function data(){
    return {
      model: null,
      address: null,
      pickupAddress: null,
      deliveryAddress: null,
      request: null,
      contact: null,
    }
  }

  function created(){
    this.getData()
  }

  function getData(){
    this.$simplecater.get(`/orders/${this.id}`).then((r)=>{
      this.model = r.data.data;
      this.$simplecater.get(`/deliveries/${this.model.delivery_id}`).then((r) => {
        const {delivery_address_id, pickup_address_id, delivery_time, date: delivery_date, notes } = r.data.data;
        this.model = { ...this.model, pickup_address_id, delivery_address_id, delivery_time, delivery_date, notes };
        if ( this.model.pickup_address_id ) {
          this.$simplecater.get(`/addresses/${this.model.pickup_address_id}`).then((r)=>{
            this.pickupAddress = r.data.data
          }).catch(()=>{
            this.$message.error("Error loading the address information")
          })
        }
        if ( this.model.request_address_id ) {
          this.$simplecater.get(`/addresses/${this.model.delivery_address_id}`).then((r)=>{
            this.deliveryAddress = r.data.data
          }).catch(()=>{
            this.$message.error("Error loading the address information")
          })
        }

        // Request
        this.$simplecater.get(`/requests/${this.model.request_id}`).then((r)=>{
          this.request = r.data.data
          // Contact
          this.$simplecater.get(`/contacts/${this.request.contact_id}`).then((r)=>{
            this.contact = r.data.data
          }).catch(()=>{
            this.$message.error("Error loading the contact information")
          })
        }).catch(()=>{
          this.$message.error("Error loading the request information")
        })
      });
    }).catch(()=>{
      this.$message.error("Error loading the data")
    })
  }

  const methods = { getData }

  const components = { LetterHead, PageContent }

  const props = {
    id: { required: true }
  }

  let computed = {
    orderItems ( ) {
      return ( this.model )? _.filter(this.model.items, ( x ) => (x.type === 'PRODUCT')) : []
    },
  }

  export default { data, components, created, methods, props, computed }
</script>

<style scoped lang="sass">
  .size 
    margin: 0 0 4mm 
  .printable-checkbox
    display: inline-block
    width: 4.5mm
    height: 4.5mm
    margin-right: 2mm
    border: 1px solid #333
    vertical-align: sub

  .signature-line
    border-top: 1px solid black
    margin: 30mm 0 0
    width: 80mm
    font-size: 0.7rem
    color: #888
    padding: 0.2rem 0 0

  .bigger
    font-size: 1.3rem

  .indent
    margin-top: 3mm
</style>



// WEBPACK FOOTER //
// src/print/OrderChecklistPDF.vue